import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  descriptionStyle: {
    fontSize: 16,
    color: Colors.dark_grey,
    lineHeight: 21,
    textAlign: 'center',
    marginTop: 19,
    fontWeight: '400',
  },
  textStyle: marginTop => ({
    fontSize: 16,
    lineHeight: 20,
    marginHorizontal: 9,
    textAlign: 'center',
    marginTop: marginTop,
  }),
});
